import axios from 'axios';

export default axios.get<string[]>('../json/customCss').then(function ({data}) {
	data?.forEach(function (path) {
		path = '../style/custom/' + path;
		window.document.head.insertAdjacentHTML('afterend', '<link rel="stylesheet" href="' + path + '">')
	})
})